import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Partner } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import DividendsOperationTableRow from './DividendsOperationTableRow';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

const DividendsOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const hasData = data.partners?.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {data.partners?.map((partner: Partner, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr className="nk-tb-item" key={`dividends-data-row-${index}`}>
              <DividendsOperationTableRow index={index} partner={partner} />
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default DividendsOperationTableBody;
